import React from 'react';
import styles from './beat-loader.module.scss';

/**
 * BeatLoader component
 * A simple beat loader animation that moves from left to right
 * with alternating colors #040704 (dark) and #DEDFDE (light gray)
 */
const BeatLoader = ({ className = '' }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className={styles.beatCircle + ' ' + styles.delay0}></div>
      <div className={styles.beatCircle + ' ' + styles.delay200}></div>
      <div className={styles.beatCircle + ' ' + styles.delay400}></div>
    </div>
  );
};

export default BeatLoader;
